var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoDiscoverLabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 -0.000488281)",
    fill: "none",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.999512C6.61553 0.999512 5.26216 1.41005 4.11101 2.17922C2.95987 2.94839 2.06266 4.04165 1.53285 5.32073C1.00303 6.59981 0.86441 8.00728 1.13451 9.36514C1.4046 10.723 2.07129 11.9703 3.05026 12.9493C4.02922 13.9282 5.2765 14.5949 6.63437 14.865C7.99224 15.1351 9.3997 14.9965 10.6788 14.4667C11.9579 13.9369 13.0511 13.0396 13.8203 11.8885C14.5895 10.7374 15 9.38398 15 7.99951C15 6.143 14.2625 4.36252 12.9497 3.04976C11.637 1.73701 9.85652 0.999512 8 0.999512ZM7 10.7949L4.5 8.29491L5.2953 7.49951L7 9.20411L10.705 5.49951L11.5029 6.29246L7 10.7949Z",
    fill: "#198038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoDiscoverLabel);
export default __webpack_public_path__ + "static/media/auto_discover_label.765f9dc664a5f51188461e61dc78f326.svg";
export { ForwardRef as ReactComponent };